import repository from "../Repository";

/**
 * OAuth認証関連のAPIにリクエストします
 */
const oauthConf = "/oauth/conf";
const userRegister = "/user/register";
const userRelease = "/user/release";
export default {
  /**
   * 認証状態を取得します
   * @param data
   */
  postConf(data) {
    return repository.post(oauthConf, data);
  },

  /**
   * ユーザー情報を登録します
   * @param data
   */
  postRegister(data) {
    return repository.post(userRegister, data);
  },

  /**
   * ユーザー情報の登録を解除します
   * @param data
   */
  postRelease(data) {
    return repository.post(userRelease, data);
  },
};



// WEBPACK FOOTER //
// ./src/api/contents/OauthUserRepository.js